import CoreRelatedNewsInsightsGrid from './CoreRelatedNewsInsightsGrid';

export { type CoreRelatedNewsInsightsGridProps } from './CoreRelatedNewsInsightsGrid';
export default CoreRelatedNewsInsightsGrid;
